import { ErrorComponentProps } from '@tanstack/react-router'
import { RefreshCwIcon } from 'lucide-react'
import errorSvg from '@/assets/error.svg'
import { StatusScreen } from '@/components/ui/status-screen'
import * as Sentry from '@sentry/react'

export function ErrorScreen({ error }: ErrorComponentProps) {
  Sentry.captureException(error)

  return (
    <StatusScreen
      image={errorSvg}
      alt="Error"
      title="Ошибка!"
      description={error.message}
      buttonContent={
        <>
          Обновить <RefreshCwIcon />
        </>
      }
      buttonProps={{
        variant: 'outline',
        onClick: () => window.location.reload(),
      }}
    />
  )
}
